import url from './url';



export default url(({ feedSource }) => `/${feedSource}`);
